import React from 'react';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import {ASSET_TYPE_PROPERTY} from '../../../../modules/ruleengine/config/consts';
import LabelValueField from './LabelValueField';
type Props = {
	assetPropertyName: string;
	assetPropertyValue: any | null | undefined;
};
const AssetPropertyTranslations: Record<string, any> = {
	[ASSET_TYPE_PROPERTY]: {
		i18nKey: `rafi.datapoints.${ASSET_TYPE_PROPERTY}`,
		defaultValue: 'Type'
	}
};
export const AssetPropertyInfoRenderer: React.FC<Props> = ({assetPropertyName, assetPropertyValue}) => {
	const {t} = useTranslation();
	const value = assetPropertyValue || '--';
	const translatedValue = t(`properties.${value}`, {
		defaultValue: value
	});
	const label = AssetPropertyTranslations[assetPropertyName];
	return <LabelValueField label={label}>{translatedValue}</LabelValueField>;
};
export default AssetPropertyInfoRenderer;
